import { VehicleWithShortDriversOutput } from '@allocab/allocab-driver-shared-types';

import { SelectControlled } from '../../components/form/SelectControlled';
import { useFethVehiclesPage } from '../../hooks/useFetchVehicles';
import { getVehicleText } from '../../utils/vehicle';

export type Props = { name: string; label?: string };

export const VehicleSelectControlled = ({ ...rest }: Props) => {
  const { data, isFetching } = useFethVehiclesPage({ limit: 100 });

  const renderItem = (vehicle: VehicleWithShortDriversOutput) => {
    return getVehicleText(vehicle);
  };

  return <SelectControlled items={data?.items} renderItem={renderItem} isFetching={isFetching} {...rest} />;
};
